import React from "react";
import PropTypes from "prop-types";
import ReactInterval from "react-interval";
import "moment/locale/ru";
import moment from "moment";
// import material-ui icons
import OpenInNewIcon from "@material-ui/icons/OpenInNew";
// import material-ui components
import { withStyles } from "@material-ui/styles";
import { DateTimePicker } from "@material-ui/pickers";
//redux components
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
//import core components
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import CardBody from "components/Card/CardBody.jsx";
import Button from "components/CustomButtons/Button.jsx";
import MonoText from "components/Typography/Mono.jsx";
import CustomInput from "components/CustomInput/CustomInput.jsx"

import {get_logs_uri} from "utils/http"

import usersStyle from "assets/jss/material-dashboard-react/views/usersStyle"

import * as actionCreators from "actions/logs";

function mapStateToProps(state) {
    return {
        token: state.auth.token,
        logs: state.logs.logs,
    };
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators(actionCreators, dispatch);
}

class LogsView extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            timeoutEnabled: false,
            fromTime: moment(new Date().setHours(0,0,0,0)),
            toTime: moment(new Date()),
            limit: 200,
            machineId: "",
        };
    }

    componentDidMount(){
        this.setState({
            timeoutEnabled: true
        });
        this.getData()
    }

    componentWillUnmount(){
        this.setState({
            timeoutEnabled: false,
        })
    }

    getData(){
        this.props.getLogs(this.props.token, ~~(this.state.fromTime.valueOf()/1000), ~~(this.state.toTime.valueOf()/1000),
            this.state.limit, this.state.machineId);
    }

    handleChangeState(type, data){
        this.setState({
            [type]: data
        }, this.getData)
    }

    render(){
        const { classes, logs } = this.props;
        return (
            <div>
                <Card>
                    <CardHeader color="success">
                        <h4>Логи</h4>
                    </CardHeader>
                    <CardBody>
                        <DateTimePicker value={this.state.fromTime} onChange={(date) => this.handleChangeState("fromTime", date)}
                                        ampm={false} invalidDateMessage="Неверный формат даты" label="От" className={classes.dateTime}
                                        okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                        />
                        <DateTimePicker value={this.state.toTime} onChange={(date) => this.handleChangeState("toTime", date)}
                                        ampm={false} invalidDateMessage="Неверный формат даты" label="От" className={classes.dateTime}
                                        okLabel="Сохранить" cancelLabel="Отменить" todayLabel="Сегодня" showTodayButton disableFuture
                        />
                        <CustomInput
                            labelText="Количество записей"
                            formControlProps={{
                                className: classes.keySearchInput,
                                fullWidth: false
                            }}
                            inputProps={{
                                value: this.state.limit,
                                onChange: e => this.handleChangeState("limit", e.target.value)
                            }}
                        />
                        <CustomInput
                            labelText="ID аппарата"
                            formControlProps={{
                                className: classes.keySearchInput,
                                fullWidth: false
                            }}
                            inputProps={{
                                value: this.state.machineId,
                                onChange: e => this.handleChangeState("machineId", e.target.value)
                            }}
                        />
                        <Button justIcon round color="transparent" 
                            onClick={()=> window.open(get_logs_uri(this.state.machineId, ~~(this.state.fromTime.valueOf()/1000), 
                                ~~(this.state.toTime.valueOf()/1000), this.state.limit, ), "_blank")}>
                                <OpenInNewIcon/>
                        </Button>
                        <MonoText>{logs.data.split("<br/>")}</MonoText>
                    </CardBody>
                </Card>
                <ReactInterval timeout={2 * 60000} enabled={this.state.timeoutEnabled} callback={() => this.getData()}/>
            </div>
        )
    }
}

LogsView.propTypes = {
    getLogs: PropTypes.func,
    logs: PropTypes.shape({
        isLoaded: PropTypes.bool,
        isLoading: PropTypes.bool,
        data: PropTypes.string,
    }),
    token: PropTypes.string,
};

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(usersStyle)(LogsView));


// WEBPACK FOOTER //
// ./src/views/Logs/Logs.jsx